import React from 'react';
import { Segment } from 'semantic-ui-react';
import { useIntl, defineMessages } from 'react-intl';
import AlignWidget from '@plone/volto/components/manage/Widgets/AlignWidget';
import FileWidget from '@plone/volto/components/manage/Widgets/FileWidget';

const messages = defineMessages({
  alignment: {
    id: 'alignment',
    defaultMessage: 'Alignment',
  },
  posterTitle: {
    id: 'posterTitle',
    defaultMessage: 'Poster',
  },
  posterDescription: {
    id: 'posterDescription',
    defaultMessage:
      "A URL to an image that displays before the video begins playing. This is often a frame of the video or a custom title screen. As soon as the user hits 'play' the image will go away.",
  },
});

const BlockConfig = (props) => {
  const { block, data, onChangeBlock, refreshPlayer } = props;
  const intl = useIntl();

  return (
    <div id="blockform-fieldset-default">
      <Segment className="form attached">
        <AlignWidget
          id="align"
          value={data.align}
          onChange={(id, value) => {
            onChangeBlock(block, {
              ...data,
              [id]: value,
            });
          }}
          key="align"
          block={block}
          title={intl.formatMessage(messages.alignment)}
        />
        <FileWidget
          id="poster"
          value={data.poster}
          onChange={(id, value) => {
            if (value) {
              onChangeBlock(block, {
                ...data,
                poster: value,
                options: {
                  ...data.options,
                  // Data url
                  poster: `data:${value['content-type']};${value.encoding},${value.data}`,
                },
              });
            } else {
              const { poster: _p, ...restData } = data;
              const { poster: _op, ...restOptions } = data.options || {};
              onChangeBlock(block, {
                ...restData,
                options: restOptions,
              });
            }
            refreshPlayer();
          }}
          key="poster"
          description={intl.formatMessage(messages.posterDescription)}
          block={block}
          title={intl.formatMessage(messages.posterTitle)}
        />
      </Segment>
    </div>
  );
};

export default BlockConfig;
